import { render, staticRenderFns } from "./zhaogu.vue?vue&type=template&id=8f294098&scoped=true"
import script from "./zhaogu.vue?vue&type=script&lang=js"
export * from "./zhaogu.vue?vue&type=script&lang=js"
import style0 from "./zhaogu.vue?vue&type=style&index=0&id=8f294098&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f294098",
  null
  
)

export default component.exports